import oktaLogo from '@/assets/images/login-okta-logo.svg';
import azureLogo from '@/assets/images/login-azure-logo.svg';

// Sign-in button copy/mark per identity provider, keyed by the SSO config's
// `identity_provider` value. String-keyed (not the `SsoIdentityProvider` union)
// so this shared presentational module stays free of a `services/` import;
// callers index with the typed provider and supply a fallback. Google is
// rendered by the dedicated branded button, so it's absent here.
export const SSO_PROVIDER_LABEL: Record<string, string> = {
  okta_oidc: 'Sign in with Okta',
  azure_oidc: 'Sign in with Azure Active Directory',
  generic_oidc: 'Sign in with OpenID SSO',
  generic_saml: 'Sign in with SAML',
};

export const SSO_PROVIDER_ICON: Record<string, string> = {
  okta_oidc: oktaLogo,
  azure_oidc: azureLogo,
};
